import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/mergeMap';
import { environment } from '../../environments/environment';
import { shareReplay, switchMap } from 'rxjs/operators';

@Injectable()
export class SetHeadersInterceptor implements HttpInterceptor {

  private tokenStatusChange$ = new Subject<boolean>();

  constructor() {
    if (window.addEventListener) {
      window.addEventListener('message', this.receiveMessage.bind(this), false);
    } else {
      (<any>window).attachEvent('onmessage', this.receiveMessage.bind(this));
    }
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.applyCredentials(req)).catch((errorResponse) => {
      if (errorResponse.status === 401) {
        // console.log('401 Unauthorized : Retry post acquiring renewed token');
        // console.log(location.origin, ' requesting  for a renewed token to Parent');
        parent.postMessage('RenewToken', '*');

        setTimeout(() => {
          this.tokenStatusChange$.complete();
          this.tokenStatusChange$ = new Subject<boolean>();
        }, 4000);

        return this.tokenStatusChange$.asObservable().pipe(switchMap((status) => {
          if (status) {
            return next.handle(this.applyCredentials(req)).do((event) => {
              if (event instanceof HttpResponse) {
                // console.log('Retry executed successfully !');
              }
            });
          }
        }), shareReplay(1));
      } else {
        return throwError(errorResponse);
      }
    });
  }

  private applyCredentials(req) {
    const apimSubscriptionKey = this.getSubscriptionKey(req.url);
    const gatewayManagerAPIKongAuthKey = this.gatewayManagerAPIKongAuthKey(req.url);
    const headers = {
      'Authorization': `Bearer ` + sessionStorage.getItem('token'),
      'OrganizationId': sessionStorage.getItem('organizationid')
    };
    if (!!apimSubscriptionKey) {
      headers['Ocp-Apim-Subscription-Key'] = apimSubscriptionKey;
    }
    if (!!gatewayManagerAPIKongAuthKey) {
      headers['fc-kong-api-key'] = gatewayManagerAPIKongAuthKey;
    }
    return req.clone({
      setHeaders: headers
    });
  }

  private receiveMessage: any = (postMessageEvent: any) => {
    if (postMessageEvent.data && postMessageEvent.data.AccessToken) {
      sessionStorage.setItem('token', postMessageEvent.data.AccessToken);
      this.tokenStatusChange$.next(true);
    }
  }

  getSubscriptionKey(url: string) {
    if (url.includes('history-validation')) {
      return environment.historyValidation.historyValidationOcpApimSubscriptionKey;
    } else if (url.includes('portal')) {
      return environment.authSettings.ocpApimSubscriptionKey;
    } else {
      return '';
    }
  }

  /**
   * Get the KONG API Key for applicable APIS
   * @param {string} url
   * @returns {string}
   */
  gatewayManagerAPIKongAuthKey(url: string) {
    if (url.includes('tenants')) {
      return environment.gatewayManagerAPIKongAuthKey;
    }
    return '';
  }
}
